// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"7fb446cd","398":"c93ab5db","624":"7d0dd233","787":"161a3b21"}[chunkId] + ".chunk.js";
};